import {zeroPadding} from "@insticator/insticator-ui";

export const generateDefaultStartDate = () => {
    let week = new Date(new Date() - (1000 * 60 * 60 * 24 * 6));
    return `${week.getFullYear()}-${zeroPadding((week.getMonth() + 1), 2)}-${zeroPadding(week.getDate(), 2)}`;
};

export const generateDefaultEndDate = () => {
    let today = new Date();
    return `${today.getFullYear()}-${zeroPadding((today.getMonth() + 1), 2)}-${zeroPadding(today.getDate(), 2)}`;
};